import type { IScrollColumnConfig } from '~/modules/heatmap/hooks';
import type { IScrollData } from './ScrollRank';

import { useHeatmapScrollConfig } from '~/modules/heatmap/hooks';
import { useHeatmapScrollContext } from '@gem-sdk/heatmap-react';
import { Box, InlineGrid } from '@shopify/polaris';
import { useCallback } from 'react';

interface ScrollRankItemProps {
  item: IScrollData;
  columns: IScrollColumnConfig[];
}

export const ScrollRankItem: React.FC<ScrollRankItemProps> = ({ item, columns }) => {
  const { ui } = useHeatmapScrollConfig();

  const setSelectedScrollY = useHeatmapScrollContext((s) => s.setSelectedScrollY);

  const _handleClick = useCallback(() => {
    setSelectedScrollY(item.endY);
  }, [item.endY, setSelectedScrollY]);

  return (
    <>
      <Box paddingInline="150" paddingBlock="500" background="bg-fill">
        <InlineGrid columns={ui.columns} gap="200">
          {columns.map((col, idx) => (
            <div key={idx}>{col.renderValue(item)}</div>
          ))}
        </InlineGrid>
      </Box>
      <div className="gx-hm-divider" />
    </>
  );
};
